export const getRequestLanguages = (filters) => {
  return !filters || filters.languageFilter?.selectedValue === 'all'
    ? undefined
    : [filters.languageFilter?.selectedValue];
};

export const getSettingsDefaultLanguage = (defaultLanguageSelectBox) => {
  return !defaultLanguageSelectBox ||
    defaultLanguageSelectBox?.selectedValue === 'all'
    ? undefined
    : [defaultLanguageSelectBox?.selectedValue];
};
